import BigNumber from 'bignumber.js'
import Box from 'UIKit/Box/Box'
import { BoxProps } from 'UIKit/Box/types'
import Skeleton from 'UIKit/Skeleton'
import Text from 'UIKit/Text'
import TokenLogo from 'UIKit/TokenLogo'
import { USD_CURRENCY } from 'config/constants/tokens'
import { RowBetween, RowCenter } from 'layout/Components/Row'
import React from 'react'
import { Trans } from 'react-i18next'
import { useTokenUsdPrice } from 'state/app/hooks'
import { useAuth } from 'state/auth/hooks'
import { useTokenSelected } from 'state/session/hooks'
import styled from 'styled-components'
import { getFullDisplayBalance } from 'utils/formatBalance'
import { InHouseLabel } from 'views/InhouseGame/components/styled'

const EstimateProfit: React.FC<{ profitInUsd: BigNumber } & BoxProps> = ({ profitInUsd, ...props }) => {
  const { hasSession } = useAuth()
  const selectedToken = useTokenSelected()
  const tokenInUsdPrice = useTokenUsdPrice(selectedToken)
  const estimateAmountInToken = new BigNumber(profitInUsd || '0').div(tokenInUsdPrice)

  return (
    <Box {...props}>
      <RowBetween>
        <InHouseLabel>
          <Trans>Profit on Win</Trans>
        </InHouseLabel>
        {hasSession && (
          <InHouseLabel>
            {estimateAmountInToken ? (
              <>
                {getFullDisplayBalance(estimateAmountInToken, 0, 6)} {selectedToken.name}
              </>
            ) : (
              <Skeleton display="inline" minWidth="50px" ml="4px" minHeight="16px !important" />
            )}
          </InHouseLabel>
        )}
      </RowBetween>

      <StyledEstProfitValue>
        <Text small>{getFullDisplayBalance(profitInUsd, 0, 2)}</Text>
        <Box pl="8px" pr="16px" minWidth={16}>
          <TokenLogo
            token={USD_CURRENCY}
            size={16}
            minWidth={16}
            networkImageProps={{
              width: 10,
              height: 10,
            }}
          />
        </Box>
      </StyledEstProfitValue>
    </Box>
  )
}

const StyledEstProfitValue = styled(RowCenter)`
  background: ${({ theme }) => theme.colors.backgroundAlt5};
  border-radius: ${({ theme }) => theme.radii.tiny};
  height: 40px;
  justify-content: flex-end;
  padding-left: 12px;
`

export default EstimateProfit
